import SpeakerHalf from './SpeakerHalf'

export default SpeakerHalf
// eslint-disable-next-line import/export
export * from './SpeakerHalf'
